import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import donation from './containers/Donation/reducer';
import poll from './containers/Poll/reducer';
import voteRegistration from './containers/VoteRegistration/reducer';
import checkRegistration from './containers/CheckRegistration/reducer';
import electionReminder from './containers/ElectionReminder/reducer';
import findPollingStation from './containers/FindPollingStation/reducer';
import quiz from './containers/Quiz/reducer';
import widget from './containers/Widget/reducer';
import localRep from './containers/LocalRep/reducer';
import call from './containers/Call/reducer';
import email from './containers/Email/reducer';
import petition from './containers/Petition/reducer';
import tweet from './containers/Tweet/reducer';
import link from './containers/Link/reducer';
import video from './containers/Video/reducer';
import volunteer from './containers/Volunteer/reducer';
import multiActionsCard from './containers/MultiActionsCard/reducer';
import actionChoiceCard from './containers/ActionChoiceCard/reducer';
import sentimentPoll from './containers/SentimentPoll/reducer';
import cachedFormData from './utils/formCaching/reducer';

const rootReducer = combineReducers({
    widget,
    poll,
    quiz,
    voteRegistration,
    checkRegistration,
    electionReminder,
    findPollingStation,
    donation,
    localRep,
    call,
    email,
    petition,
    tweet,
    link,
    video,
    volunteer,
    multiActionsCard,
    actionChoiceCard,
    sentimentPoll,
    cachedFormData,
    router: routerReducer,
    form: formReducer
});

export default rootReducer;
